import type { ExperimentConfig } from '@seek/candidate-feature-flag';

export const launchDarklyExperiments: ExperimentConfig[] = [];
